import React from 'react';
import { makeStyles } from '@material-ui/core';
import type { CustomHelperProps } from 'reactour';

const useStyles = makeStyles(() => ({
  card: {
    width: 420,
    maxWidth: '92vw',
    borderRadius: 12,
    overflow: 'hidden',
    background: '#fff',
    boxShadow: '0 0.5em 3em rgba(0, 0, 0, 0.3)',
  },
}));

// Passed as `CustomHelper` to <Tour>. This replaces reactour's default helper wrapper
export function Card({ content }: CustomHelperProps) {
  const classes = useStyles();

  return <div className={classes.card}>{content}</div>;
}

export default Card;
